import { PRODUCT_TYPES } from '../../services/ProductTypeState'
import type { PricingPayload } from '../../stores/cartStore/adapters/CartItemAdapter.types'

type GroupOrder = {
  productType: string
  products: PricingPayload['products']
  variantsIds: string[]
  discountId?: string
}

export function buildGroupOrders(
  payloads: PricingPayload[],
  variantsIds: string[],
  discountId: string | undefined
): GroupOrder[] {
  const discountProductType = payloads.every(
    (payload) => payload.productType === PRODUCT_TYPES.PHOTO_BOOK
  )
    ? PRODUCT_TYPES.PHOTO_BOOK
    : PRODUCT_TYPES.CLASSIC

  return payloads.map((payload) => ({
    productType: payload.productType,
    products: payload.products,
    variantsIds,
    ...(payload.productType === discountProductType ? { discountId } : {}),
  }))
}

export function buildCheckoutSummaryParams({
  productType,
  pricingCountry,
  variantsIds,
  products,
  address,
  checkoutId,
  discountId,
  promocode,
  giftCodes,
  curExecutionId,
}: {
  productType: string
  pricingCountry?: string
  variantsIds?: string[]
  products?: unknown
  address?: unknown
  checkoutId?: string
  discountId?: string | null
  promocode?: string | null
  giftCodes?: string[]
  curExecutionId?: string
}) {
  return {
    productType,
    pricingCountry,
    variantsIds,
    products,
    address,
    checkoutId,
    discountId,
    // This endpoint does not persist the coupon on the checkout document, so an
    // absent key is safe here, unlike the group request below.
    promocode: promocode || undefined,
    giftCodes: productType === PRODUCT_TYPES.GIFT_CARD ? [] : giftCodes,
    // maintains request order in the backend as well
    timestamp: Date.now(),
    curExecutionId,
  }
}

export function buildGroupCheckoutSummaryParams({
  orders,
  pricingCountry,
  address,
  checkoutId,
  promocode,
  giftCodes,
  curExecutionId,
}: {
  orders: GroupOrder[]
  pricingCountry?: string
  address?: unknown
  checkoutId?: string
  promocode?: string | null
  giftCodes?: string[]
  curExecutionId?: string
}) {
  return {
    orders,
    pricingCountry,
    checkoutId,
    address,
    // Sent explicitly rather than omitted: the server persists this on a reused
    // Checkout document, so an absent key leaves a removed coupon in place.
    promocode: promocode || null,
    giftCodes,
    timestamp: Date.now(),
    curExecutionId,
  }
}
